import { render, staticRenderFns } from "./WoLFeedbackEdit.vue?vue&type=template&id=3d0b8f9e&scoped=true&"
import script from "./WoLFeedbackEdit.vue?vue&type=script&lang=js&"
export * from "./WoLFeedbackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b8f9e",
  null
  
)

export default component.exports